import useAsclepius from "@common/composables/api/asclepius"
import { reactive, Ref, ref, watch } from "vue"
import {
  BenefitsApiListCompanyBenefitEnrollmentsRequest,
  CompanyBenefitDTO,
  CompanyBenefitEnrollment,
  BenefitsApiSearchCompanyBenefitEnrollmentsRequest
} from "@vitable/asclepius-api-client-ts"

export const useGetCompanyBenefits = () => {
  const { getBenefitsApi, callWithResponse, callResult } = useAsclepius()
  const benefits: Ref<Array<CompanyBenefitDTO>> = ref([])

  async function getCompanyBenefits(companyId: string) {
    await callWithResponse(() =>
      getBenefitsApi().listActiveCompanyBenefits({
        companyId: companyId
      })
    )
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      benefits.value = newValue.data.benefits
    }
  })

  return {
    benefits,
    getCompanyBenefits,
    getCompanyBenefitsResult: callResult
  }
}

export const useGetUpcomingCompanyBenefits = () => {
  const { getBenefitsApi, callWithResponse, callResult } = useAsclepius()
  const benefits: Ref<Array<CompanyBenefitDTO>> = ref([])

  async function getUpcomingCompanyBenefits(companyId: string) {
    await callWithResponse(() =>
      getBenefitsApi().listUpcomingCompanyBenefits({
        companyId: companyId
      })
    )
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      benefits.value = newValue.data.benefits
    }
  })

  return {
    benefits,
    getUpcomingCompanyBenefits,
    getUpcomingCompanyBenefitsResult: callResult
  }
}

export const useGetBenefitPlanEnrollments = () => {
  const { getBenefitsApi, callWithResponse, callResult } = useAsclepius()
  const enrollmentsPaginated = reactive<Paginated<CompanyBenefitEnrollment>>({
    currentPage: 1,
    nextPage: undefined,
    prevPage: undefined,
    totalCount: 0,
    results: []
  })

  async function getCompanyBenefitEnrollments(request: BenefitsApiListCompanyBenefitEnrollmentsRequest) {
    request = { ...request, page: enrollmentsPaginated.currentPage }
    await callWithResponse(() => getBenefitsApi().listCompanyBenefitEnrollments(request))
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      enrollmentsPaginated.results = newValue.data.results
      // @ts-ignore
      enrollmentsPaginated.nextPage = newValue.data.next
      // @ts-ignore
      enrollmentsPaginated.prevPage = newValue.data.previous
      // @ts-ignore
      enrollmentsPaginated.totalCount = newValue.data.count
    }
  })

  return {
    enrollmentsPaginated,
    getCompanyBenefitEnrollments,
    getCompanyBenefitEnrollmentsResult: callResult
  }
}

export const useGetCompanyBenefit = () => {
  const { getBenefitsApi, callWithResponse, callResult } = useAsclepius()
  const companyBenefit: Ref<Nullable<CompanyBenefitDTO>> = ref(null)

  async function getCompanyBenefit(companyBenefitId: string) {
    await callWithResponse(() =>
      getBenefitsApi().getCompanyBenefit({
        companyBenefitId: companyBenefitId
      })
    )
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      companyBenefit.value = newValue.data.benefit
    }
  })

  return {
    companyBenefit,
    getCompanyBenefit,
    getCompanyBenefitResult: callResult
  }
}

export function useSearchCompanyBenefitEnrollments() {
  const { getBenefitsApi, callWithResponse, callResult } = useAsclepius()
  const enrollmentsPaginated = reactive<Paginated<CompanyBenefitEnrollment>>({
    currentPage: 1,
    nextPage: undefined,
    prevPage: undefined,
    totalCount: 0,
    results: []
  })

  async function searchCompanyBenefitEnrollments(request: BenefitsApiSearchCompanyBenefitEnrollmentsRequest) {
    await callWithResponse(() => getBenefitsApi().searchCompanyBenefitEnrollments(request))
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      enrollmentsPaginated.results = newValue.data.results
      // @ts-ignore
      enrollmentsPaginated.nextPage = newValue.data.next
      // @ts-ignore
      enrollmentsPaginated.prevPage = newValue.data.previous
      // @ts-ignore
      enrollmentsPaginated.totalCount = newValue.data.count
    }
  })

  return {
    enrollmentsPaginated,
    searchCompanyBenefitEnrollments,
    searchCompanyBenefitEnrollmentsResult: callResult
  }
}
